import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Stack, Text } from '@nike/podium';
import { TeamMemberCard } from './TeamMemberCard';
/**
 * Displays a list of team members with consistent styling.
 * Used across Expression and Project detail views.
 *
 * @param members - Array of team members to display
 * @param emptyMessage - Message shown when no members exist
 * @param variant - Display style passed to TeamMemberCard
 * @param groupTitle - Optional title for the group (e.g., team name)
 */
export function TeamMemberList({ members, emptyMessage = 'No team members assigned', variant = 'card', groupTitle }) {
    const validMembers = members.filter((m) => m.name);
    if (validMembers.length === 0) {
        return (_jsx(Text, { font: "body-2", className: "pds-color-text-secondary", children: emptyMessage }));
    }
    return (_jsxs(Stack, { gap: "m", children: [groupTitle && _jsx(Text, { font: "body-2-strong", children: groupTitle }), validMembers.map((member) => (_jsx(TeamMemberCard, { role: member.role, name: member.name, email: member.email, variant: variant }, member.key)))] }));
}
